import styled from '@emotion/styled';
import {
  DatePicker as AntDatePicker,
  TimePicker as AntTimePicker,
  InputNumber as AntInputNumber,
  InputNumberProps,
  Typography,
} from 'antd';
import { EnhancedSelect as _EnhancedSelect } from 'common/components/EnhancedSelect/EnhancedSelect';

const ACTIVE_TAB_HEADER_COLOR = '#000';
const TAB_HEADER_COLOR = '#8C8C8C';

export const SSwapContainer = styled.div`
  position: absolute;
  top: -14px;
  right: 0;
`;

export const SSelectGroup = styled.div`
  position: relative;
`;

export const SEnhancedSelect = styled(_EnhancedSelect)`
  width: 100%;
  &:not(:first-of-type) .ant-select-selector {
    border-left: 0;
  }
`;

export const SDivider = styled.div`
  border: 1px dashed #d9d9d9;
`;

export const SDatePicker = styled(AntDatePicker)`
  width: 245px;
`;

export const STimePicker = styled(AntTimePicker)`
  width: 128px;
`;

export const SInputNumber = styled(AntInputNumber)<InputNumberProps>`
  width: 100%;
  margin-top: 8px;
`;

export const SText2 = styled(Typography.Text)`
  font-size: 16px;
  line-height: 22px;
`;

export const SText3 = styled(Typography.Text)`
  font-size: 24px;
  line-height: 22px;
`;

export const SGroup = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SSelectRow = styled.div`
  margin-top: 8px;
  display: flex;
  & ${SEnhancedSelect}:first-of-type {
    width: 25%;
    & .ant-select-selection-item {
      font-size: 13px;
    }
  }
  & ${SEnhancedSelect}:not(:first-of-type) {
    width: 75%;
  }
`;

export const STabWrapper = styled.div`
  background: white;
  width: 460px;

  .ant-tabs {
    .ant-tabs-nav {
      padding: 0 16px;
    }

    .ant-tabs-tab .ant-tabs-tab-btn {
      color: ${TAB_HEADER_COLOR};
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${ACTIVE_TAB_HEADER_COLOR};
    }
    .ant-tabs-ink-bar {
      background: ${ACTIVE_TAB_HEADER_COLOR};
    }
    .ant-tabs-tab:hover {
      color: ${ACTIVE_TAB_HEADER_COLOR};
    }
  }
`;

export const SFormContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 77px;
`;

export const SContainer = styled.div`
  padding: 0 16px 16px;
`;
